import React from 'react';
import { withTranslation } from 'react-i18next';
import './ErrorBoundary.css';

// Error boundary de app: convierte un error de render (que de otro modo deja
// la pantalla en blanco y obliga a Ctrl+F5) en un fallback amigable con opción
// de recargar. Alinea con el gate anti-blank-screen (NER-1345). Debe ser un
// class component: los error boundaries no tienen equivalente en hooks.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught an error:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    const { t, children } = this.props;

    if (this.state.hasError) {
      return (
        <div className="error-boundary" role="alert">
          <div className="error-boundary-card">
            <h1>{t('errorBoundary.title', 'Algo salió mal')}</h1>
            <p>
              {t(
                'errorBoundary.message',
                'Ocurrió un error inesperado. Tus datos se guardaron correctamente. Recargá la página para continuar.'
              )}
            </p>
            <button type="button" className="btn btn-primary" onClick={this.handleReload}>
              {t('errorBoundary.reload', 'Recargar página')}
            </button>
          </div>
        </div>
      );
    }

    return children;
  }
}

export default withTranslation()(ErrorBoundary);
